import HistoryDepositComponent from '@components/history-deposit';
import * as React from 'react';

export interface IHistoryDepositProps {}

export default function HistoryDeposit(props: IHistoryDepositProps) {
  return <HistoryDepositComponent />;
}
